<template>
  <div class="form-group">
    <div class="input-group">
      <input :type="type || 'datetime-local'"
             :id="id"
             :name="name"
             v-model="date"
             :disabled="disabled"
             :readonly="readonly"
             :class="date == null ? 'no-value' : 'has-value'"/>
      <label class="control-label" :for="id">
        <slot name="label">{{ label }}</slot>
      </label>
      <i class="bar"></i>
    </div>
    <slot name="icon"></slot>
  </div>
</template>

<script>
  import moment from 'moment';

  function generateRandomId () {
    return Math.floor(Math.random() * Math.pow(10, 10));
  }

  export default {
    name: 'vuestic-datetime',
    props: {
      value: {},
      label: String,
      id: {
        type: String,
        default () {
          // We require unique id to show label
          return 'label-' + generateRandomId();
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: '',
      },
      type: String,
    },
    computed: {
      date: {
        get () {
          if (this.value == null) return;
          switch (this.type) {
            case 'time':
              return moment.duration(this.value).format('HH:mm:ss.SSS', {trim: false});
            case 'date':
              return moment(this.value).format('YYYY-MM-DD');
            default:
              return moment(this.value).format('YYYY-MM-DDTHH:mm:ss.SSS');
          }
        },
        set (v) {
          this.$emit('input', v ? (
            this.type === 'time'
              ? moment.duration(v)
              : moment(v)
          ) : null);
        },
      },
    },
  };
</script>

<style lang="scss">
  .vuestic-checkbox {

  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-datetime/VuesticDatetime.vue